import { useState } from "react";
import { styled } from "styled-components";
import theme from "../../styles/theme";

const StyledLabel = styled.label<{ $checked: boolean }>`
  display: inline-block;
  border-radius: 10px;
  background-color: ${({ theme, $checked }) =>
    $checked ? theme.colors.link : theme.colors.bg};
  text-align: center;
  margin: 0 20px 20px 0;
  padding: 12px 21.5px 12px 28px;
  outline-style: outset;
  outline-color: ${({ theme, $checked }) =>
    $checked ? theme.colors.link : theme.colors.tertiary};
  user-select: none;
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    inset: 2px;
    background-color: ${({ theme }) => theme.colors.quarteriary};
    border-radius: inherit;
  }

  span.name {
    display: inline-flex;
    transform: ${({ $checked }) => ($checked ? "translateX(-5px)" : "none")};
    transition: transform 0.2s ease;
    color: ${({ theme, $checked }) =>
      $checked ? theme.colors.link : theme.colors.text1};
    position: relative;
    z-index: 2;
  }

  span.checkmark {
    display: inline-flex;
    visibility: ${({ $checked }) => ($checked ? "visible" : "hidden")};
    transform: ${({ $checked }) => ($checked ? "translateX(5px)" : "none")};
    transition: transform 0.2s ease;
    color: ${({ theme, $checked }) =>
      $checked ? theme.colors.link : theme.colors.text1};
    position: relative;
    z-index: 2;
  }
`;

interface CheckBoxProps {
  name: string;
  onCheckBoxChange: (
    name: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export default function CheckBox({ name, onCheckBoxChange }: CheckBoxProps) {
  const [checked, setChecked] = useState(false);

  return (
    <StyledLabel $checked={checked}>
      <input
        type="checkbox"
        onChange={(e) => {
          setChecked(!checked);
          onCheckBoxChange(name, e);
        }}
        style={{ display: "none" }}
      />
      <span style={{ fontWeight: "bold" }} className="name">
        {name}
      </span>
      <span className="checkmark">
      <img
        src="/fonts/check-solid.svg" height={theme.fontSize.medium} />
      </span>
    </StyledLabel>
  );
}
